import { styled } from '@mui/material'

export const IconContainer = styled('div', { name: 'IconContainer' })({
  transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'absolute',
  opacity: 1,
  right: 0,
})
